export default __webpack_public_path__ + "static/media/feedback-blue.38d3861e.svg";